import styled, { css } from 'styled-components';
import { lineHeight, theme, toRem } from 'design';

interface ActionMenuItemProps {
  isActive?: boolean;
  disabled?: boolean;
}

const ActionMenuItem = styled.li<ActionMenuItemProps>`
  position: relative;
  z-index: ${theme.zIndex.header + 3};
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${toRem(theme.dropdown.item.height.mobile)};
  margin-bottom: ${toRem(theme.space.xs)};
  padding: 0 ${toRem(theme.space.md)};
  border-radius: ${toRem(5.5)};
  border: ${toRem(1)} solid transparent;
  background-color: transparent;
  list-style: none;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.medium};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  text-decoration: none;
  color: ${theme.color.neutral[900]};
  cursor: pointer;
  transition: background-color ${theme.transition.button.default};

  @media (min-width: ${theme.breakpoint.small}px) {
    height: ${toRem(theme.dropdown.item.height.desktop)};
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background-color: ${theme.color.neutral[100]};
  }

  &:focus {
    border-color: rgba(0, 0, 0, 0.055);
    outline: none;
  }

  &:visited,
  &:active {
    text-decoration: none;
    color: ${theme.color.neutral[900]};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${theme.color.neutral[100]};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${theme.color.neutral[400]};

      &:hover {
        background-color: ${theme.color.white};
        cursor: not-allowed;
      }

      &:active {
        color: ${theme.color.neutral[400]};
      }

      &:focus {
        background-color: ${theme.color.white};
      }
    `}
`;

export default ActionMenuItem;
